<style lang='scss' scoped>
// 动画关键帧
@keyframes navGradient {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes navGlow {
  0%, 100% { 
    box-shadow: 0 2px 10px rgba(0, 212, 255, 0.3);
    border-bottom-color: rgba(0, 212, 255, 0.3);
  }
  50% { 
    box-shadow: 0 2px 20px rgba(0, 212, 255, 0.6);
    border-bottom-color: rgba(0, 212, 255, 0.8);
  }
}

.nav-top {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  
  // 深色赛博朋克渐变背景
  background: linear-gradient(-45deg, #0a0e27, #1a1f3a, #0d1b2a, #09659A);
  background-size: 400% 400%;
  animation: navGradient 15s ease infinite;
  
  color: #fff;
  z-index: 250;
  white-space: nowrap;
  
  // 底部发光边框
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
  box-shadow: 0 2px 10px rgba(0, 212, 255, 0.3);
  animation: navGlow 3s ease-in-out infinite;
  
  // 顶部细线装饰
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.5), transparent);
    animation: navGradient 5s linear infinite;
  }
  
  & > * {
    position: relative;
    height: inherit;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 6px;
    transition: all 0.3s ease;
  }

  .nav-logo {
    overflow: hidden;
    width: 208px;
    position: relative;
    
    // Logo 容器发光效果
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 140px;
      height: 40px;
      background: radial-gradient(circle, rgba(0, 212, 255, 0.15) 0%, transparent 70%);
      border-radius: 50%;
      pointer-events: none;
      animation: navGlow 4s ease-in-out infinite;
    }
    
    img {
      width: 127px;
      height: 31px;
      position: relative;
      z-index: 1;
      filter: drop-shadow(0 0 8px rgba(0, 212, 255, 0.5));
      transition: all 0.3s ease;
    }
    
    &:hover img {
      filter: drop-shadow(0 0 15px rgba(0, 212, 255, 0.8));
      transform: scale(1.02);
    }
  }
  
  .nav-logo.nav-logo2 {
    width: auto;
    img {
      width: auto;
      height: 33px;
    }
  }
}
</style>


<template>
  <nav class="nav-top clearfix">
    <aside v-if="isSpecialUser"
           class="nav-logo nav-logo2 pull-left">
      <a href="/home">
        <img src="../../../image/logo2.png"
             alt="logo" />
      </a>
    </aside>
    <aside v-else class="nav-logo pull-left">
      <a v-if="hasLogo" href="/home">
        <img :src="logosrcurl" alt="logo" />
      </a>
      <a v-else-if="isUCandPort" href="/home">
        <img src="../../../image/tongyi.png" alt="logo" />
      </a>
       <a v-else-if="isShowQlinYun" href="/home">
        <img src="../../../image/logo_qlinyun_default.png" alt="logo" />
      </a>
      <a v-else href="/home">
        <img src="../../../image/onep.png" alt="logo" />
      </a>
    </aside>
    <comp-navlist style="flex-grow:1;" class="pull-left"></comp-navlist>
    <comp-lang class="pull-right"></comp-lang>
    <comp-userinfo class="pull-right"></comp-userinfo>
    <comp-sys class="pull-right"></comp-sys>
    <comp-notice class="pull-right"></comp-notice>
    <comp-search v-if="showSearch" class="pull-right"></comp-search>
<!--    <comp-guidance class="pull-right"></comp-guidance>-->
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import myHelper from "@mods/utils/helper";
import {
    SOCIAL_HOST_STUB_QLINYUN
} from "@mods/service/base";
import compUserinfo from './userinfo';
import compSys from './sys/index';
import compNavlist from './navlist';
import compLang from './lang';
import compNotice from './notice/index';
import compSearch from './search/index';
//import compGuidance from './guidance/index';
export default {
  components: {
    compUserinfo,
    compSys,
    compLang,
    compNavlist,
    compNotice,
    compSearch,
    //compGuidance
  },
  data () {
    return {
      // logourl:''
      showSearch: true
    }
  },
  computed: {
    ...mapState(['userinfo', 'organization']),
    //自定义logo
    hasLogo () {
       console.log(this.userinfo,'useruseruser');
       console.log(this.organization,'organization');
      return this.organization.logo ? this.organization.logo && /^https?:\/\//.test(this.organization.logo) : this.userinfo.organization.logo && /^https?:\/\//.test(this.userinfo.organization.logo)
    },
    logosrcurl(){
        return this.organization.logo ? this.organization.logo : this.userinfo.organization.logo
    },
    isSpecialUser () {
      // Demon@onepinnovate.com
      //erp 特色用户
      return process.env.VUE_APP_PROJECT_ID == 8 && /^Demon@onepinnovate\.com/gi.test(this.userinfo.email)
    },
    // port系统和uc系统展示不一样的logo
    isUCandPort () {
      return /port.onepinnovate.com|uc-adm.onepinnovate.com/i.test(window.location.href)
    },
    isShowQlinYun () {
        return myHelper.hostStubMatch(window.location.hostname, SOCIAL_HOST_STUB_QLINYUN);
    }
  },
};
</script>
